import React from 'react';
import { Facebook } from 'lucide-react';
import { ASSOC } from '../mock';
import { useAuth } from '../context/AuthContext';

export default function Footer() {
  const year = new Date().getFullYear();
  const { settings, org } = useAuth();
  const layout = (settings && settings.layout) || {};
  const title = (settings && settings.header && settings.header.title) || (org && org.name) || ASSOC.name;
  const motto = (settings && settings.header && settings.header.motto) || (org && org.tagline) || ASSOC.motto;
  return (
    <footer style={{ background: 'var(--olive)' }} className="mt-auto">
      <div className="max-w-6xl mx-auto px-4 py-8 text-center">
        {layout.showSocial !== false && (
          <div className="flex items-center justify-center gap-4 mb-4">
            {['RAE Tas', '12 Fd Sqn', 'RAE Australia'].map((g) => (
              <a
                key={g}
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                title={g}
                className="flex items-center justify-center w-9 h-9 rounded-full transition-transform hover:scale-110"
                style={{ background: 'var(--navy)', color: 'var(--cream)' }}
              >
                <Facebook size={18} />
              </a>
            ))}
          </div>
        )}
        <p className="font-title text-sm" style={{ color: 'var(--cream)' }}>
          © {year} {title}
        </p>
        <p className="font-title italic text-xs mt-1" style={{ color: 'rgba(244,241,232,0.75)' }}>
          {motto}
        </p>
        <a href="/about" data-testid="footer-about-link" className="inline-block font-title text-xs mt-2 underline" style={{ color: 'rgba(244,241,232,0.85)' }}>
          About this app
        </a>
      </div>
    </footer>
  );
}
